import React, { useState, useEffect } from 'react';
import api from '../services/api';
import './Craques.css';

export default function Craques() {
  const [ranking, setRanking] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/jogadores/ranking').then(setRanking).catch(() => {}).finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="loading"><div className="spinner" /></div>;

  return (
    <div className="craques-page">
      <h1 className="page-title">⭐ Quem são os 50 craques mais escolhidos?</h1>
      {ranking.length === 0 ? <p className="empty">Nenhum craque escolhido ainda.</p> : ranking.map(j => (
        <div key={j.id} className={`ranking-item${j.posicao <= 3 ? ` top${j.posicao}` : ''}`}>
          <span className="rank-pos">{j.posicao === 1 ? '🥇' : j.posicao === 2 ? '🥈' : j.posicao === 3 ? '🥉' : `#${j.posicao}`}</span>
          <div className="rank-info">
            <span className="rank-nome">{j.nome} - {j.time_nome}</span>
            <span className="rank-sub">Escolhido por {j.escolhas.toLocaleString('pt-BR')} torcedores</span>
          </div>
        </div>
      ))}
    </div>
  );
}
